import { Component, EventEmitter, Input, OnChanges, SimpleChanges, Output } from '@angular/core';
import { InputComponent, MakeProvider } from '../input-component';

@Component({
  selector: 'app-select-input',
  templateUrl: './select-input.component.html',
  styleUrls: ['./select-input.component.scss', '../form-inputs-style.scss'],
  providers: [MakeProvider(SelectInputComponent)]
})
export class SelectInputComponent extends InputComponent implements OnChanges {

  @Input() interface = 'popover';
  @Input() allowMultiple = false;
  @Input() options: SelectOption[] = [];
  @Input() includeNullOption: boolean = false;
  @Input() nullOptionString: string = '-- None --';
  @Input() includeAddOption: boolean = false;
  @Input() addOptionString: string = '-- Add --';
  @Input() minWidth = '200px';
  @Input() maxWidth;

  @Output() onValueSelected: EventEmitter<any> = new EventEmitter<any>();

  override errorMessage = 'Select an option';

  constructor() { super(); }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['options']) {
      if ( this.includeAddOption ) {
        if (!this.options.some(item => item.value === 0)) {
          this.options.unshift({value: 0, displayValue: this.addOptionString});
        }
      }
  
      if ( this.includeNullOption ) {
        if (!this.options.some(item => item.value === null)) {
          this.options.unshift({value: null, displayValue: this.nullOptionString});
        }
      }
    }
   }

  override checkValidity() {
    super.checkValidity();
    if (this.isValid) {
      this.checkingValidity.emit(this);
    }
  }
  valueSelected(){
    this.onValueSelected.emit(this.value);
  }
}

export interface SelectOption {
  value: any;
  displayValue: string;
}
